<template>
  <div class="stk-py-6">
    <RecommendationsInbox />
  </div>
</template>

<script>
import RecommendationsInbox from '@frontend/ui/features/tasks/components/recommendations/RecommendationsInbox.vue';

export default {
  name: 'ActionCenterInboxView',
  components: {
    RecommendationsInbox,
  },
};
</script>
